import { render, staticRenderFns } from "./DepotList.vue?vue&type=template&id=0e8b0d7a&"
import script from "./DepotList.vue?vue&type=script&lang=js&"
export * from "./DepotList.vue?vue&type=script&lang=js&"
import style0 from "./DepotList.vue?vue&type=style&index=0&id=0e8b0d7a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports